exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.loginbox{\r\n    margin-top: 0!important;\r\n}\r\n\r\n.panel-info {\r\n    border-color: #465255;\r\n}\r\n.jumbotron {\r\n    padding-top: 0.45rem;\r\n}\r\n\r\n.panel-info>.panel-heading {\r\n    color: #ffffff;\r\n    background-color: #337ab7;\r\n    border-color: #333333;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main